import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoaderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  min-height: 100px;
`;

const Spinner = styled.div`
  width: 32px;
  height: 32px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #FFC107;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const LoadingText = styled.div`
  margin-left: 12px;
  color: #666;
  font-size: 14px;
`;

const ComponentLoader = ({ text = 'Loading component...' }) => (
  <LoaderContainer>
    <Spinner />
    <LoadingText>{text}</LoadingText>
  </LoaderContainer>
);

export default ComponentLoader;